/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Section_BasicsInputs */

const cs_property_section_basics = /** @type {(inputs: Property_Section_BasicsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Základní údaje`)
};

const en_property_section_basics = /** @type {(inputs: Property_Section_BasicsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Basics`)
};

/**
* | output |
* | --- |
* | "Basics" |
*
* @param {Property_Section_BasicsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_section_basics = /** @type {((inputs?: Property_Section_BasicsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Section_BasicsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_section_basics(inputs)
	return cs_property_section_basics(inputs)
});